import React from 'react'
import About from '../components/about/About'
import Contact from '../components/contact/Contact'
import Experience from '../components/experience/Experience'
import Footer from '../components/footer/Footer'
import Header from '../components/header/Header'
import Portfolio from '../components/portfolio/Portfolio'
import Services from '../components/services/Services'
import Testimonial from '../components/testimonial/Testimonial'
import Background from '../assets/background-image-front.jpg'
import TitleText from '../utils/TitleText'
import TopNav from '../components/topnav/TopNav'
import Gesture from '../assets/gesture-recognition.jpg'
import NotFound from '../pages/404'
import GestureRecognition from '../pages/GestureRecognition'
const Home = () => {
    const footitems=[
        {sec:'#',title:'Home'},
        {sec:'#about',title:'About'},
        {sec:'#skills',title:'Skills'},
        {sec:'#experience',title:'Experience'},
        {sec:'#projects',title:'Projects'},
        {sec:'#testimonial',title:'Testimonials'},
        {sec:'#contact',title:'Contact'},

    ]
    TitleText('Home : AS')
  return (
    <>  

    
            <Header text1="Hello I'm" text2="Anmol Sharma" text3="Software Engineer" img={Background}  />
            <TopNav/>
            <About/>
            <Experience/>
            <Services/>
            <Portfolio/>
            <Testimonial/>
            <Contact/>
            <Footer footitems={footitems}/>
    
    
    </>
  )
}

export default Home